import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ListenerForm from './ListenerForm'

const ListenerDialog = React.forwardRef(function ListenerDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, listener: null })

  const isEdit = !!dialogState.listener

  const close = useCallback(() => {
    setDialogState({ open: false, listener: null })
  }, [])

  const handleComplete = useCallback(() => {
    close()
    onComplete?.()
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (listener = null) => {
      setDialogState({ open: true, listener })
    }
  }), [])

  return (
    <SydModal
      open={dialogState.open}
      onClose={close}
      title={isEdit ? 'Edit Listener' : 'Create Listener'}
      size='medium'
    >
      <div>
        {dialogState.open ? (
          <ListenerForm
            existing={dialogState.listener}
            onCancel={close}
            onComplete={handleComplete}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ListenerDialog.propTypes = {
  onComplete: PropTypes.func
}

export default ListenerDialog
